import { Button, Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { InvoiceItem } from "../../../../types/invoice/AddInvoice";
import { Edit, Trash2 } from "react-feather";

interface DisplayItemRowProps {
    item: InvoiceItem;
    itemIdx: number;
    replace: (index: number, obj: InvoiceItem) => void;
    remove: () => void;
    t: (key: string) => string;
  }
  
 export const DisplayItemRow: React.FC<DisplayItemRowProps> = ({ item, itemIdx, replace, remove, t }) => (
    <Card className="bg-light rounded-3 mb-2 w-100">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h6 className="mb-2">{String(item.item || "")}</h6>
            <div className="row text-muted small">
              <div className="col-md-3">
                <strong>{t("Quantity")}:</strong> {String(item.quantity || "")}
              </div>
              <div className="col-md-3">
                <strong>{t("Price")}:</strong> ${Number(item.price || 0).toFixed(2)}
              </div>
              <div className="col-md-3">
                <strong>{t("Tax Rate")}:</strong> {item.taxRate}%
              </div>
              <div className="col-md-3">
                <strong>{t("Discount")}:</strong> ${Number(item.discount || 0).toFixed(2)}
              </div>
              <div className="col-md-3">
                <strong>{t("Total")}:</strong>
                <span className="text-success fw-bold ms-1">${(item.total || 0).toFixed(2)}</span>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-end gap-2 ms-auto">
            <Button
              className="p-0"
              id={`edit-item-${itemIdx}`}
              color="link"
              size="sm"
              type="button"
              onClick={() => replace(itemIdx, { ...item, isEditing: true })}
            >
              <Edit size={18} />
            </Button>
            <UncontrolledTooltip target={`edit-item-${itemIdx}`}>
              {t("Edit Item")}
            </UncontrolledTooltip>
            <Button
              className="p-0"
              id={`delete-item-${itemIdx}`}
              color="link"
              size="sm"
              type="button"
              onClick={remove}
            >
              <Trash2 size={18} />
            </Button>
            <UncontrolledTooltip target={`delete-item-${itemIdx}`}>
              {t("Delete Item")}
            </UncontrolledTooltip>
          </div>
        </div>
      </CardBody>
    </Card>
  );